import Vuex from 'vuex'
import Vue from 'vue'
import chatModule from './chatModule'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: { chatModule: chatModule }
})

export default store
